import React, { useCallback, useMemo } from 'react';

import { getParentalRatingIcon } from 'assets/images';

import {
    DESCRIPTION_PARENTAL_RATING_CONTENT,
    ICON_PARENTAL_RATING_CONTENT,
    TITLE_PARENTAL_RATING_CONTENT,
} from 'config/testID';

import { EventParentalControlRating } from 'services/data-manager/types';

import DialogView from 'components/Dialog';

import { parentalRatingContentKeys } from './constants';
import styles from './styles';

type Props = {
    visible: boolean;
    parentalRating?: EventParentalControlRating;
};

const ContentRatingOverlay = ({ visible, parentalRating }: Props) => {
    const parentalRatingContent = useMemo(() => {
        if (!parentalRating) {
            return parentalRatingContentKeys[
                EventParentalControlRating.HU_GENERAL
            ];
        }
        return parentalRatingContentKeys[parentalRating];
    }, [parentalRating]);

    const ParentalRatingIcon = useMemo(
        () => getParentalRatingIcon(parentalRating),
        [parentalRating],
    );

    const renderIconComponent = useCallback(
        () => (
            <ParentalRatingIcon
                testID={ICON_PARENTAL_RATING_CONTENT}
                width={48}
                height={48}
                style={styles.icon}
            />
        ),
        [],
    );

    return (
        <DialogView
            supportedOrientation={[
                'landscape',
                'landscape-left',
                'landscape-right',
                'portrait',
                'portrait-upside-down',
            ]}
            visible={visible}
            title={parentalRatingContent.title}
            titleTestID={TITLE_PARENTAL_RATING_CONTENT}
            description={parentalRatingContent.description}
            descriptionTestID={DESCRIPTION_PARENTAL_RATING_CONTENT}
            IconComponent={renderIconComponent}
            style={styles.container}
        />
    );
};

export default ContentRatingOverlay;
